import { render } from "./ComponentHeader.vue?vue&type=template&id=192d5b82"
import script from "./ComponentHeader.vue?vue&type=script&lang=js"
export * from "./ComponentHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__